import React from 'react'
import styled from 'styled-components'
import { LIGHTGRAY } from '../../styles/colors.style'

const StyledList = styled.ul`
	list-style: none;
	padding: 0;
	text-align: center;

	& > li {
		font-size: 15px;
		margin-top: 7px;

		&:first-child {
			margin-top: 0;
		}
	}
`

const StyledDiv = styled.div`
	border-bottom: 1px solid ${LIGHTGRAY};
	font-size: 3rem;
	margin-top: 3rem;
	padding-bottom: 2rem;
	text-align: center;
`

const List = ({ title, items }) => {
	return (
		<div>
			<div>
				{typeof title === 'string' ? (
					<StyledDiv className="orange semi-bold">{title}</StyledDiv>
				) : (
					title()
				)}
			</div>
			<StyledList>
				{items.map((item, index) => (
					<li key={index}>{item}</li>
				))}
			</StyledList>
		</div>
	)
}

export default List
